import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingSku } from './types';

export function useBillingBundleCandidates() {
  const { data, error, isLoading, mutate } = useSWR<TBillingSku[]>(
    'commenda-billing/catalog/bundle-candidates',
    SWRFetcher({ method: 'GET' })
  );

  return { skus: data ?? [], error, isLoading, mutate };
}
